var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46143 10.0873H8.30554C8.55518 10.0873 8.75928 10.3306 8.75928 10.6275V16.3158C8.75928 16.6131 8.5553 16.8562 8.30554 16.8562H2.46143C2.21204 16.8562 2.00769 16.6131 2.00769 16.3158V10.6275C2.00769 10.3306 2.21204 10.0873 2.46143 10.0873ZM10.6943 2H16.5386C16.7883 2 16.9923 2.24305 16.9923 2.54032V8.22856C16.9923 8.52583 16.7883 8.76864 16.5386 8.76864H10.6943C10.4447 8.76864 10.241 8.52583 10.241 8.22856V2.54032C10.241 2.24305 10.4447 2 10.6943 2ZM2.45337 2H8.29785C8.54749 2 8.75159 2.24305 8.75159 2.54032V8.22856C8.75159 8.52583 8.54761 8.76864 8.29785 8.76864H2.45337C2.20398 8.76864 2 8.52583 2 8.22856V2.54032C2 2.24305 2.20398 2 2.45337 2ZM10.702 10.2315H16.5463C16.7957 10.2315 17 10.4745 17 10.7719V16.4602C17 16.7571 16.7957 17.0001 16.5463 17.0001H10.702C10.4524 17.0001 10.2483 16.7571 10.2483 16.4602V10.7719C10.2483 10.4745 10.4524 10.2315 10.702 10.2315Z",
    fill: "#FCE025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard-1.7ae6f833e7d3ce3ec7630332d764f360.svg";
export { ForwardRef as ReactComponent };